"use client";

import { useCallback, useState } from "react";

import ConfigureModal from "@/features/enrollment/components/configure-modal";
import { useConfigureStore } from "@/features/enrollment/store/configure-store";
import { ExportModal } from "@/features/search/components/actions/export";
import { usePipelineJob } from "@/features/jobs/context/pipeline-job-context";
import type { PipelineCandidate } from "@/lib/api/types";

import { usePipelineProfileExport } from "../export-jobs";

export function usePipelineRowContextActions() {
  const { job } = usePipelineJob();
  const setConfigure = useConfigureStore((s) => s.set);

  const [activeCandidate, setActiveCandidate] =
    useState<PipelineCandidate | null>(null);
  const [exportModalOpen, setExportModalOpen] = useState(false);
  const [enrollModalOpen, setEnrollModalOpen] = useState(false);
  const profileExport = usePipelineProfileExport(activeCandidate);

  const openExport = useCallback((candidate: PipelineCandidate) => {
    setActiveCandidate(candidate);
    setExportModalOpen(true);
  }, []);

  const openEnroll = useCallback(
    (candidate: PipelineCandidate) => {
      setConfigure({
        jobId: job.id,
        jobCandidateIds: [candidate.job_candidate_id],
        sequenceId: null,
      });
      setEnrollModalOpen(true);
    },
    [job.id, setConfigure],
  );

  const modals = (
    <>
      <ConfigureModal open={enrollModalOpen} onOpenChange={setEnrollModalOpen} />
      <ExportModal
        open={exportModalOpen}
        onClose={() => setExportModalOpen(false)}
        profileCount={1}
        source={profileExport.source}
        onExport={profileExport.startExport}
      />
    </>
  );

  return { openExport, openEnroll, modals };
}
